import { render, staticRenderFns } from "./statisics.vue?vue&type=template&id=5e9c62d0&scoped=true"
import script from "./statisics.vue?vue&type=script&lang=js"
export * from "./statisics.vue?vue&type=script&lang=js"
import style0 from "./statisics.vue?vue&type=style&index=0&id=5e9c62d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9c62d0",
  null
  
)

export default component.exports